import IconTitleSection from './IconTitleSection';

export default IconTitleSection;
